module.exports = __webpack_public_path__ + "img/6.341f9ccf.jpg";